/**
 * @param {import('@nuxtjs/axios').NuxtAxiosInstance} client
 * */
export default (client, { apiPaymentUrl }) => {
  const root = `${apiPaymentUrl}/withdrawal`

  return {
    /** @returns {Promise<AxiosResponse<TaxRates>>} */
    getTaxRates() {
      const url = `${apiPaymentUrl}/tax/rates`
      return client.get(url)
    },

    getPaymentsWithdrawal() {
      const url = `${root}/types`
      return client.get(url)
    },

    async withdrawal(data) {
      const url = root
      return client.post(url, data)
    },

    withdrawalBonuses() {
      const url = `${root}/bonus`
      return client.get(url)
    },

    withdrawalCard(data) {
      const url = `${root}/card`
      return client.post(url, data)
    },

    cancelWithdrawal(data) {
      const url = `${root}/cancel`
      return client.post(url, data)
    },

    withdrawalInn(data) {
      const url = `${root}/inn`
      return client.get(url, data)
    },
  }
}

/**
 * @typedef {Object} TaxRates
 * @property {number} tax_ndfl_percent
 * @property {number} tax_voen_percent
 */
